/* Çiftlik teması — tema betikleri */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var root = routes.root || '/';
  if (root.slice(-1) !== '/') root += '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ---------- Bildirim ---------- */
  var toastTimer;
  function toast(message, isError) {
    var el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.toggle('toast--error', !!isError);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Çekmeceler (menü ve sepet) ---------- */
  var lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('is-locked');
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    if (!$$('.drawer:not([hidden])').length) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { e.preventDefault(); openDrawer($('[data-menu-drawer]')); }
    if (t.closest('[data-menu-close]')) { closeDrawer($('[data-menu-drawer]')); }
    if (t.closest('[data-cart-close]')) { closeDrawer($('[data-cart-drawer]')); }
    var cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && window.theme.cartType === 'drawer' && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer($('[data-cart-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.drawer:not([hidden])').forEach(closeDrawer);
      closeFacets();
      closePredictive();
    }
  });

  /* ---------- Sepet ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartDrawer(sectionsHtml) {
    if (!sectionsHtml || !sectionsHtml['cart-drawer']) return;
    var doc = parseHTML(sectionsHtml['cart-drawer']);
    var newDrawer = doc.querySelector('[data-cart-drawer]');
    var current = $('[data-cart-drawer]');
    if (!newDrawer || !current) return;
    var newInner = newDrawer.querySelector('.drawer__panel');
    var curInner = current.querySelector('.drawer__panel');
    if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
  }

  function refreshCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  // Zorunlu kişiselleştirme alanlarını kontrol et
  function validateRequired(form) {
    if (!form.id) return true;
    var missing = $$('[data-required-property][form="' + form.id + '"]').filter(function (input) {
      var empty = !input.value.trim();
      input.classList.toggle('is-invalid', empty);
      return empty;
    });
    if (!missing.length) return true;
    var errorBox = form.querySelector('[data-form-error]');
    var msg = 'Lütfen "' + missing[0].getAttribute('data-required-property') + '" alanını doldurun.';
    if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; }
    else toast(msg, true);
    missing[0].focus();
    return false;
  }

  // Sepete ekle (ürün sayfası ve ürün kartları)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!validateRequired(form)) { e.preventDefault(); return; }
    if (window.theme.cartType === 'page') return; // normal gönderim
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-form-error]');
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var msg = res.data.description || res.data.message || 'Ürün sepete eklenemedi.';
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; }
          else toast(msg, true);
          return;
        }
        renderCartDrawer(res.data.sections);
        refreshCartCount();
        var drawer = $('[data-cart-drawer]');
        if (drawer) openDrawer(drawer);
        else toast('Ürün sepete eklendi');
      })
      .catch(function () { toast('Bir hata oluştu, lütfen tekrar deneyin.', true); })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
      });
  });

  // Yan sepette adet değiştir / kaldır
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-drawer] [data-line]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line'), 10);
    var qty = Math.max(0, parseInt(btn.getAttribute('data-qty'), 10));
    var panel = btn.closest('.drawer__panel');
    if (panel) panel.style.opacity = '.6';

    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) { toast(cart.description || cart.message, true); return; }
        renderCartDrawer(cart.sections);
        updateCartCount(cart.item_count);
      })
      .catch(function () { toast('Sepet güncellenemedi.', true); })
      .finally(function () { if (panel) panel.style.opacity = ''; });
  });

  /* ---------- Adet seçici ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '0', 10);
    var val = (parseInt(input.value, 10) || 0) + step;
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Varyant seçimi ---------- */
  function initVariantPicker(section) {
    var picker = section.querySelector('[data-variant-picker]');
    if (!picker) return;
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var sectionId = section.getAttribute('data-section-id');
    var productUrl = section.getAttribute('data-product-url');

    function selectedOptions() {
      return $$('[data-option-index]', picker).map(function (group) {
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        return checked ? checked.value : select ? select.value : null;
      });
    }

    function findVariant(options) {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    function markAvailability(options) {
      // Seçili diğer seçeneklere göre olmayan kombinasyonları işaretle
      $$('[data-option-index]', picker).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        $$('input', group).forEach(function (input) {
          var test = options.slice();
          test[idx] = input.value;
          var match = findVariant(test);
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update() {
      var options = selectedOptions();
      var variant = findVariant(options);
      markAvailability(options);

      $$('[data-selected-value]', picker).forEach(function (el, i) { el.textContent = options[i] || ''; });

      var idInputs = $$('input[name="id"]', section);
      var buttons = $$('[data-add-button]', section);

      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = 'Bu seçenek yok'; });
        return;
      }

      idInputs.forEach(function (i) { i.value = variant.id; });

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.featured_media) {
        var slide = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) goToSlide(section, slide);
      }

      // Fiyat, stok ve buton bölümlerini sunucudan yeniden al
      fetch(productUrl + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          ['[data-price-block]', '[data-stock]', '[data-sku]', '[data-buy-buttons-state]', '[data-sticky-price]'].forEach(function (sel) {
            var fresh = doc.querySelectorAll(sel);
            var current = section.querySelectorAll(sel);
            current.forEach(function (el, i) { if (fresh[i]) el.innerHTML = fresh[i].innerHTML; });
          });
          buttons.forEach(function (b) {
            b.disabled = !variant.available;
            var label = b.querySelector('span');
            if (label) label.textContent = variant.available ? 'Sepete Ekle' : 'Tükendi';
          });
        });
    }

    picker.addEventListener('change', update);
    markAvailability(selectedOptions());
  }

  /* ---------- Galeri ---------- */
  function goToSlide(section, slide) {
    var track = slide.parentElement;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    var id = slide.getAttribute('data-media-id');
    $$('[data-thumb]', section).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === id);
    });
  }

  function initGallery(section) {
    var track = section.querySelector('[data-gallery-track]');
    if (!track) return;
    $$('[data-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var slide = section.querySelector('[data-media-id="' + thumb.getAttribute('data-thumb') + '"]');
        if (slide) goToSlide(section, slide);
      });
    });
    track.addEventListener('scroll', debounce(function () {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      var slide = track.children[index];
      if (!slide) return;
      var id = slide.getAttribute('data-media-id');
      $$('[data-thumb]', section).forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb') === id);
      });
    }, 80));
  }

  /* ---------- Görsel büyütme (tam ekran) ---------- */
  function initLightbox(section) {
    var dialog = section.querySelector('[data-lightbox]');
    var triggers = $$('[data-zoom-src]', section);
    if (!dialog || !triggers.length || typeof dialog.showModal !== 'function') return;
    var stage = dialog.querySelector('[data-lightbox-stage]');
    var img = document.createElement('img');
    stage.appendChild(img);
    var count = dialog.querySelector('[data-lightbox-count]');
    var prev = dialog.querySelector('[data-lightbox-prev]');
    var next = dialog.querySelector('[data-lightbox-next]');
    var zoomBtn = dialog.querySelector('[data-lightbox-zoom]');
    var thumbsBox = dialog.querySelector('[data-lightbox-thumbs]');
    var current = 0;
    var single = triggers.length < 2;

    // Alttaki küçük görseller
    var thumbs = [];
    if (!single && thumbsBox) {
      triggers.forEach(function (t, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lightbox__thumb';
        b.setAttribute('aria-label', 'Görsel ' + (i + 1));
        var ti = document.createElement('img');
        ti.src = t.getAttribute('data-zoom-thumb') || t.getAttribute('data-zoom-src');
        ti.alt = '';
        ti.loading = 'lazy';
        b.appendChild(ti);
        b.addEventListener('click', function () { show(i); });
        thumbsBox.appendChild(b);
        thumbs.push(b);
      });
    } else if (thumbsBox) {
      thumbsBox.hidden = true;
    }
    prev.hidden = single; next.hidden = single; count.hidden = single;

    // Yakınlaştırma: görselin gerçek boyutunu aşmaz (en fazla 2 kat)
    function updateZoomable() {
      var shown = img.offsetWidth;
      var scale = shown ? Math.min(2, img.naturalWidth / shown) : 1;
      dialog.style.setProperty('--lb-scale', scale.toFixed(2));
      dialog.classList.toggle('can-zoom', scale >= 1.2);
      if (scale < 1.2) setZoom(false);
    }
    function setZoom(on, e) {
      dialog.classList.toggle('is-zoomed', on);
      zoomBtn.setAttribute('aria-label', on ? 'Uzaklaştır' : 'Yakınlaştır');
      if (!on) img.style.transformOrigin = '';
      else if (e) moveZoom(e);
    }
    function moveZoom(e) {
      if (!dialog.classList.contains('is-zoomed')) return;
      // Büyütme öncesi kutuya göre fare konumu (yüzde)
      var s = stage.getBoundingClientRect();
      var x = (e.clientX - s.left - img.offsetLeft) / img.offsetWidth * 100;
      var y = (e.clientY - s.top - img.offsetTop) / img.offsetHeight * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      img.style.transformOrigin = x + '% ' + y + '%';
    }
    img.addEventListener('load', updateZoomable);
    window.addEventListener('resize', function () { if (dialog.open) updateZoomable(); });

    function show(i) {
      current = (i + triggers.length) % triggers.length;
      var t = triggers[current];
      setZoom(false);
      dialog.classList.remove('can-zoom');
      img.style.animation = 'none';
      void img.offsetWidth;
      img.style.animation = '';
      img.src = t.getAttribute('data-zoom-src');
      img.alt = t.getAttribute('data-zoom-alt') || '';
      count.textContent = (current + 1) + ' / ' + triggers.length;
      thumbs.forEach(function (b, n) {
        b.classList.toggle('is-active', n === current);
        if (n === current && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center' });
      });
      if (img.complete && img.naturalWidth) updateZoomable();
    }

    triggers.forEach(function (t, i) {
      t.addEventListener('click', function () {
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        show(i);
      });
    });

    prev.addEventListener('click', function () { show(current - 1); });
    next.addEventListener('click', function () { show(current + 1); });
    zoomBtn.addEventListener('click', function () { setZoom(!dialog.classList.contains('is-zoomed')); });
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () { document.documentElement.style.overflow = ''; setZoom(false); });

    // Masaüstü: görsele tıklayınca yakınlaştır, fareyle gez
    img.addEventListener('click', function (e) {
      if (!dialog.classList.contains('can-zoom') || window.matchMedia('(hover: none)').matches) return;
      setZoom(!dialog.classList.contains('is-zoomed'), e);
    });
    img.addEventListener('mousemove', moveZoom);

    // Koyu alana tıklayınca kapat
    stage.addEventListener('click', function (e) { if (e.target === stage) dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target === thumbsBox) dialog.close(); });

    dialog.addEventListener('keydown', function (e) {
      if (single) return;
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });

    // Telefonda kaydırarak geçiş (tek parmak)
    var startX = null;
    stage.addEventListener('touchstart', function (e) { startX = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null || single || (window.visualViewport && window.visualViewport.scale > 1)) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  /* ---------- Mobil sabit sepete ekle ---------- */
  function initStickyAtc(section) {
    var bar = section.querySelector('[data-sticky-atc]');
    var mainForm = section.querySelector('[data-main-buy]');
    if (!bar || !mainForm || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(mainForm);
    var btn = bar.querySelector('button');
    if (btn) btn.addEventListener('click', function () {
      var submit = mainForm.querySelector('[type="submit"]');
      if (submit) submit.click();
    });
  }

  /* ---------- Kaydırıcılar ---------- */
  function initCarousel(el) {
    var track = el.querySelector('[data-carousel-track]');
    var prev = el.querySelector('[data-carousel-prev]');
    var next = el.querySelector('[data-carousel-next]');
    if (!track) return;
    function updateButtons() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    track.addEventListener('scroll', debounce(updateButtons, 50));
    window.addEventListener('resize', debounce(updateButtons, 150));
    updateButtons();
  }

  function initSlideshow(el) {
    var track = el.querySelector('[data-slideshow-track]');
    var dots = $$('[data-slide-dot]', el);
    if (!track) return;
    var count = track.children.length;
    var current = 0;
    var timer;
    var interval = parseInt(el.getAttribute('data-autoplay') || '0', 10) * 1000;

    function go(i) {
      current = (i + count) % count;
      track.scrollTo({ left: track.clientWidth * current, behavior: 'smooth' });
    }
    function setActive() {
      current = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); d.setAttribute('aria-current', i === current); });
    }
    function start() {
      if (!interval || count < 2) return;
      stop();
      timer = setInterval(function () { go(current + 1); }, interval);
    }
    function stop() { clearInterval(timer); }

    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); start(); }); });
    var prev = el.querySelector('[data-carousel-prev]');
    var next = el.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); start(); });
    if (next) next.addEventListener('click', function () { go(current + 1); start(); });
    track.addEventListener('scroll', debounce(setActive, 60));
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    start();
  }

  /* ---------- Duyuru çubuğu ---------- */
  function initRotator(el) {
    var items = $$('.announcement__item', el);
    if (items.length < 2) return;
    var i = 0;
    var ms = parseInt(el.getAttribute('data-interval') || '5', 10) * 1000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, ms);
  }

  /* ---------- Sekmeler ---------- */
  function initTabs(el) {
    var tabs = $$('[role="tab"]', el);
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(index + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      var carousel = panel && panel.querySelector('[data-carousel]');
      if (carousel) carousel.dispatchEvent(new Event('scroll'));
    }
  }

  /* ---------- Canlı arama ---------- */
  var predictiveController;
  function closePredictive() {
    $$('[data-predictive-results]').forEach(function (el) { el.hidden = true; });
  }

  function initPredictive(wrap) {
    var input = wrap.querySelector('[data-predictive-input]');
    var results = wrap.querySelector('[data-predictive-results]');
    if (!input || !results || !routes.predictiveSearch) return;

    var search = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      if (predictiveController) predictiveController.abort();
      predictiveController = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor,tag' +
        '&section_id=predictive-search';
      fetch(url, predictiveController ? { signal: predictiveController.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var inner = doc.querySelector('.predictive-search__inner');
          results.innerHTML = inner ? inner.outerHTML : '';
          results.hidden = !inner;
        })
        .catch(function () {});
    }, 250);

    input.addEventListener('input', search);
    input.addEventListener('focus', function () { if (results.innerHTML.trim()) results.hidden = false; });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) results.hidden = true; });
  }

  /* ---------- Filtreler ---------- */
  function closeFacets() {
    var f = $('[data-facets]');
    if (f) { f.classList.remove('is-open'); document.body.classList.remove('is-locked'); }
  }

  function initFacets() {
    var form = $('[data-facets-form]');
    if (!form) return;
    var isDesktop = window.matchMedia('(min-width: 990px)');
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-price-input]')) return;
      if (isDesktop.matches) submitFacets(form);
    });
    $$('[data-price-input]', form).forEach(function (input) {
      input.addEventListener('change', function () { if (isDesktop.matches) submitFacets(form); });
    });
    $$('[data-facets-open]').forEach(function (b) {
      b.addEventListener('click', function () { $('[data-facets]').classList.add('is-open'); document.body.classList.add('is-locked'); });
    });
    $$('[data-facets-close]').forEach(function (b) { b.addEventListener('click', closeFacets); });

    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function submitFacets(form) {
    var params = new URLSearchParams(new FormData(form));
    // Boş fiyat alanlarını gönderme
    Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
    var current = new URL(window.location.href);
    var sortBy = current.searchParams.get('sort_by');
    if (sortBy) params.set('sort_by', sortBy);
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  /* ---------- Kişiselleştirme (küpe) ---------- */
  var TAG_COLORS = {
    'yeşil': '#4C9A2A', 'yesil': '#4C9A2A', 'green': '#4C9A2A',
    'sarı': '#F2C230', 'sari': '#F2C230', 'yellow': '#F2C230',
    'turuncu': '#F07F1E', 'orange': '#F07F1E',
    'turkuaz': '#2BB3B1', 'turquoise': '#2BB3B1',
    'mavi': '#2F6FC6', 'blue': '#2F6FC6', 'lacivert': '#24387A',
    'pembe': '#E86FA6', 'pink': '#E86FA6',
    'kırmızı': '#D33A2C', 'kirmizi': '#D33A2C', 'red': '#D33A2C',
    'beyaz': '#F2F2F2', 'white': '#F2F2F2',
    'mor': '#7D4FB0', 'purple': '#7D4FB0',
    'gri': '#9A9A9A', 'grey': '#9A9A9A', 'gray': '#9A9A9A',
    'siyah': '#3A3A3A', 'black': '#3A3A3A',
    'kahverengi': '#7A4B2A', 'brown': '#7A4B2A'
  };

  function fitSvgText(el, maxWidth) {
    el.removeAttribute('textLength');
    el.removeAttribute('lengthAdjust');
    try {
      if (el.getComputedTextLength() > maxWidth) {
        el.setAttribute('textLength', maxWidth);
        el.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      }
    } catch (err) { /* görünmüyorsa ölçülemez */ }
  }

  function initPersonalization(section) {
    var box = section.querySelector('[data-personalization]');
    if (!box) return;
    var upper = box.getAttribute('data-uppercase') === 'true';
    var svg = box.querySelector('.ear-tag');
    var qtyInput = section.querySelector('input[name="quantity"]');
    var numberInput = box.querySelector('[data-preview-target="number"]');
    var rangeEl = box.querySelector('[data-number-range]');

    function setPreview(target, value) {
      if (!svg) return;
      $$('[data-preview="' + target + '"]', svg).forEach(function (t) {
        t.textContent = value;
        fitSvgText(t, target === 'number' ? 80 : 74);
      });
    }

    function updateRange() {
      if (!numberInput || !rangeEl) return;
      var raw = numberInput.value || '01';
      var start = parseInt(raw, 10);
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (isNaN(start)) { rangeEl.textContent = ''; return; }
      var end = start + qty - 1;
      var width = raw.length;
      function pad(n) { var s = String(n); while (s.length < width) s = '0' + s; return s; }
      rangeEl.textContent = qty > 1 ? 'Basılacak numaralar: ' + pad(start) + ' – ' + pad(end) : 'Basılacak numara: ' + pad(start);
    }

    $$('[data-preview-target]', box).forEach(function (input) {
      var target = input.getAttribute('data-preview-target');
      var counter = input.parentElement.querySelector('[data-char-count]');
      function handle() {
        if (target === 'number') {
          var digits = input.value.replace(/\D/g, '');
          if (digits !== input.value) input.value = digits;
        } else if (upper) {
          var up = input.value.toLocaleUpperCase('tr-TR');
          if (up !== input.value) {
            var pos = input.selectionStart;
            input.value = up;
            try { input.setSelectionRange(pos, pos); } catch (err) {}
          }
        }
        if (input.value.trim()) input.classList.remove('is-invalid');
        if (counter) counter.textContent = input.value.length;
        var fallback = target === 'number' ? '01' : target === 'line1' ? input.placeholder : '';
        setPreview(target, input.value || fallback);
        if (target === 'number') updateRange();
      }
      input.addEventListener('input', handle);
      handle();
    });

    // Önizleme rengini seçilen "Renk" seçeneğine göre değiştir
    function updateColor() {
      if (!svg) return;
      var color = box.getAttribute('data-default-color');
      $$('[data-option-name]', section).forEach(function (group) {
        if (!/renk|color|colour/i.test(group.getAttribute('data-option-name'))) return;
        var checked = group.querySelector('input:checked');
        if (!checked) return;
        var key = checked.value.toLocaleLowerCase('tr-TR').trim();
        var match = TAG_COLORS[key];
        if (!match) {
          Object.keys(TAG_COLORS).some(function (name) {
            if (key.indexOf(name) !== -1) { match = TAG_COLORS[name]; return true; }
            return false;
          });
        }
        if (match) color = match;
      });
      svg.style.setProperty('--tag-color', color);
    }

    var picker = section.querySelector('[data-variant-picker]');
    if (picker) picker.addEventListener('change', updateColor);
    if (qtyInput) qtyInput.addEventListener('change', updateRange);
    if (qtyInput) qtyInput.addEventListener('input', updateRange);
    updateColor();
    updateRange();
  }

  /* ---------- WhatsApp ile sipariş ---------- */
  // Tıklanınca mesajı seçilen seçenek, adet ve kişiselleştirme bilgileriyle yeniden oluşturur
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-whatsapp-order]');
    if (!link) return;
    var section = link.closest('[data-product-section]');
    var lines = [link.getAttribute('data-message'), '', 'Ürün: ' + link.getAttribute('data-title')];

    if (section) {
      var options = $$('[data-option-name]', section).map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? group.getAttribute('data-option-name') + ': ' + checked.value : null;
      }).filter(Boolean);
      lines = lines.concat(options);

      var qty = section.querySelector('input[name="quantity"]');
      if (qty && qty.value) lines.push('Adet: ' + qty.value);

      var form = section.querySelector('[data-product-form]');
      if (form && form.id) {
        $$('[form="' + form.id + '"][name^="properties["]', section).forEach(function (input) {
          var v = input.value.trim();
          if (!v) return;
          var name = input.name.slice(11, -1);
          if (name.charAt(0) === '_') return;
          lines.push(name + ': ' + v);
        });
      }
    }

    var variantId = section && section.querySelector('input[name="id"]');
    var url = link.getAttribute('data-url');
    if (variantId && variantId.value) url += '?variant=' + variantId.value;
    lines.push('Sayfa: ' + url);

    link.href = 'https://wa.me/' + link.getAttribute('data-phone') + '?text=' + encodeURIComponent(lines.join('\n'));
  });

  /* ---------- Benzer ürünler ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.getAttribute('data-loaded')) return;
    el.setAttribute('data-loaded', 'true');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          $$('[data-carousel]', el).forEach(initCarousel);
        }
      })
      .catch(function () {});
  }

  /* ---------- Başlat ---------- */
  function init() {
    $$('[data-recommendations]').forEach(initRecommendations);
    $$('[data-product-section]').forEach(function (section) {
      initVariantPicker(section);
      initGallery(section);
      initLightbox(section);
      initStickyAtc(section);
      initPersonalization(section);
    });
    $$('[data-carousel]').forEach(initCarousel);
    $$('[data-slideshow]').forEach(initSlideshow);
    $$('[data-rotator]').forEach(initRotator);
    $$('[data-tabs]').forEach(initTabs);
    $$('[data-predictive-search]').forEach(initPredictive);
    initFacets();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Tema düzenleyicisinde bölüm yeniden yüklenince tekrar başlat
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    $$('[data-carousel]', t).forEach(initCarousel);
    $$('[data-slideshow]', t).forEach(initSlideshow);
    $$('[data-rotator]', t).forEach(initRotator);
    $$('[data-tabs]', t).forEach(initTabs);
    $$('[data-predictive-search]', t).forEach(initPredictive);
    $$('[data-product-section]', t).forEach(function (s) { initVariantPicker(s); initGallery(s); initLightbox(s); initStickyAtc(s); initPersonalization(s); });
  });
})();
